import { defineElement, BaseElement } from '@webtides/element-js';

class PrintButton extends BaseElement {
    animateScrollEntrances = document.querySelectorAll('animate-scroll-antrance') || [];
    hiddenElements = document.querySelectorAll('show-hide') || [];

    properties() {
        return {
            isClicked: false,
            hiddenElementHeight: 0,
        };
    }

    executePageAnimationAndLazyLoad() {
        if (this.animateScrollEntrances.length > 0) {
            this.animateScrollEntrances.forEach((animate) => {
                animate.enter();
            });
        }
        if (this.hiddenElements.length > 0) {
            this.hiddenElements.forEach((hidden) => {
                const hiddenItems = hidden.querySelectorAll('.download-item').length;
                // 275px is each QRcode height
                this.hiddenElementHeight = hidden.$refs.content.style.maxHeight;
                hidden.$refs.content.style.maxHeight = 275 * hiddenItems + 'px';
            });
        }
    }

    setInitialStateOfElements() {
        if (this.hiddenElements.length > 0) {
            this.hiddenElements.forEach((hidden) => {
                hidden.$refs.content.style.maxHeight = this.hiddenElementHeight;
                this.isClicked = false;
            });
        }
    }

    events() {
        return {
            this: {
                click: () => {
                    if (!this.isClicked) {
                        this.executePageAnimationAndLazyLoad();
                        this.isClicked = true;
                    }
                    window.print();
                    window.onafterprint = this.setInitialStateOfElements();
                },
            },
        };
    }
}

export function define() {
    defineElement('print-button', PrintButton);
}
